import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

// interface that could be adapted to use for objs in weather_list
// interface Provider {
//   region: string,
//   country: string,
//   locale: string,
//   company: string
// }

// let countryProviders: Array<Provider>;
// let allProviders: Array<Provider>;

export interface IState {
  initial: number;
  current: object;
  weather_list: any[];
}

const defaultState = (): IState => {
  return {
    initial: 1,
    weather_list: [],
    current: {},
  };
};

const module = {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};

export { module as default };
